import { ManifestValidationError, parseAppManifest, serializeAppManifest, validateCapabilities, } from "@tchoma/manifest";
import { createShortcutProgram, } from "@tchoma/shortcut-ir";
export { CAPABILITIES, ManifestValidationError, isCompatibilityRange, normalizeAllowedOrigin, normalizePublicUrl, parseAppManifest, serializeAppManifest, validateAppManifest, } from "@tchoma/manifest";
export { ShortcutBuilder, ShortcutIrValidationError, createShortcutProgram, parseShortcutProgram, serializeShortcutProgram, validateShortcutProgram, } from "@tchoma/shortcut-ir";
export function defineApp(definition) {
    return parseAppManifest(definition);
}
export function defineShortcut(definition) {
    return definition;
}
export function capabilities(values) {
    const issues = validateCapabilities(values);
    if (issues.length > 0)
        throw new ManifestValidationError(issues);
    return [...values].sort();
}
export function shortcut(entry, options) {
    return {
        entry,
        ...(options.name === undefined ? {} : { name: options.name }),
        accepts: [...options.accepts],
        showInShareSheet: options.showInShareSheet ?? false,
        showOnAppleWatch: options.showOnAppleWatch ?? false,
    };
}
export function syncProvider(provider, features) {
    return { provider, ...features };
}
export function cloudflare(features) {
    return syncProvider("cloudflare", features);
}
export function localOnly() {
    return {
        local: "indexeddb",
        blobs: "opfs-with-indexeddb-fallback",
        sync: syncProvider("none", { documents: false, blobs: false, realtime: false }),
    };
}
export function runtimeManifest(definition) {
    return serializeAppManifest(definition);
}
export function createAppShortcut(app, build, options = {}) {
    const manifest = parseAppManifest(app);
    return createShortcutProgram({
        name: manifest.surfaces.shortcut.name,
        inputs: manifest.surfaces.shortcut.accepts,
        outputTypes: options.outputTypes ?? [],
        capabilities: manifest.capabilities,
        minimumClientVersion: options.minimumClientVersion ?? manifest.minimum.shortcutClient ?? 900,
        icon: {
            glyph: manifest.icon.shortcutGlyph,
            color: manifest.icon.shortcutColor,
        },
        availability: {
            ios: manifest.minimum.ios,
            macos: manifest.minimum.macos,
        },
        importQuestions: options.importQuestions ?? [],
    }, build);
}
//# sourceMappingURL=index.js.map